var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F0EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 33C25.8069 33 28.8926 28.0751 28.8926 22C28.8926 15.9249 25.8069 11 22.0005 11C18.1941 11 15.1084 15.9249 15.1084 22C15.1084 28.0751 18.1941 33 22.0005 33Z",
    stroke: "#541DC9",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6935 19.3076H19.3076V24.6935H24.6935V19.3076Z",
    stroke: "#541DC9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2529 23.3691H19.3069",
    stroke: "#541DC9",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2529 20.6768H19.3069",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6309 17.2529V19.3069",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3232 17.2529V19.3069",
    stroke: "#541DC9",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7463 20.6309H24.6924",
    stroke: "#541DC9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7463 23.3232H24.6924",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3691 26.7463V24.6924",
    stroke: "#541DC9",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6768 26.7463V24.6924",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3154 22H22.6847",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28.8926C28.0751 28.8926 33 25.8069 33 22.0005C33 18.1941 28.0751 15.1084 22 15.1084C15.9249 15.1084 11 18.1941 11 22.0005C11 25.8069 15.9249 28.8926 22 28.8926Z",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechStackIcon);
export default __webpack_public_path__ + "static/media/tech-stack-icon.169b7eca2ccd6fcd3bf03f25beccabc2.svg";
export { ForwardRef as ReactComponent };